import {
    Component,
    Input,
    OnInit,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { FormArray, FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { InspectionModel, DraftInspection } from '../../../models/inspection.model';

export function positiveNumberValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
        return null;
    }

    const numValue = Number(value);
    if (isNaN(numValue)) {
        return { 'notANumber': true };
    }

    if (numValue <= 0) {
        return { 'positiveRequired': true };
    }

    return null;
}

@Component({
    selector: 'app-inspection-table',
    templateUrl: './inspection-table.component.html',
    styleUrls: ['./inspection-table.component.scss']
})
export class InspectionTableComponent implements OnInit, OnChanges {

    @Input() previousInspections: InspectionModel[] = [];
    @Input() currentInspection: DraftInspection | null = null;
    @Input() threshold!: number;
    @Input() formArray!: FormArray;

    rowIndices: number[] = [];
    minRowCount = 0;


    get columns(): string[] {
        const cols = ['indexColumn'];
        this.previousInspections.forEach((_, i) => {
            cols.push('past-' + i);
        });
        cols.push('current');
        return cols;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['previousInspections'] || changes['formArray']) {
            this.buildRows();
        }
    }

    ngOnInit(): void {
        this.buildRows();
        // Appliquer le validateur à tous les contrôles existants
        this.applyValidatorsToExistingControls();
    }

    private applyValidatorsToExistingControls(): void {
        if (this.formArray) {
            // Pour chaque contrôle dans le formArray
            for (let i = 0; i < this.formArray.length; i++) {
                const control = this.formArray.at(i) as FormControl;
                // Ajouter le validateur s'il n'existe pas déjà
                if (!control.hasValidator(positiveNumberValidator)) {
                    control.addValidators(positiveNumberValidator);
                    control.updateValueAndValidity();
                }
            }
        }
    }

    private buildRows(): void {
        const maxPast = Math.max(0, ...this.previousInspections.map(i => i.measurements.length));
        this.minRowCount = maxPast;
        const currentRows = this.formArray.length;
        const maxRows = Math.max(maxPast, currentRows);
        this.rowIndices = Array.from({ length: maxRows }, (_, i) => i);

        // Ajouter des contrôles avec validateurs si nécessaire
        while (this.formArray.length < maxRows) {
            const newControl = new FormControl(null, [positiveNumberValidator]);
            this.formArray.push(newControl);
        }
    }

    getPastValue(colIndex: number, rowIndex: number): number | null {
        const insp = this.previousInspections[colIndex];
        if (!insp || !insp.measurements[rowIndex]) return null;
        return insp.measurements[rowIndex].value;
    }

    getCurrentControl(rowIndex: number): FormControl {
        return this.formArray.at(rowIndex) as FormControl;
    }

    onAddRow(): void {
        // Ajouter un nouveau contrôle avec validateur
        const newControl = new FormControl(null, [positiveNumberValidator]);
        this.formArray.push(newControl);

        const newIndex = this.rowIndices.length;
        this.rowIndices = [...this.rowIndices, newIndex];
    }

    isOverThreshold(rowIndex: number): boolean {
        const val = this.getCurrentControl(rowIndex).value;
        if (val == null || this.threshold == null) return false;
        return +val > this.threshold;
    }

    protected readonly origin = origin;
}
